module.exports = __webpack_public_path__ + "static/tm-blackHawk-7f87a0a25aeb0ffc7d769783f722310d.png";